import { CHANGE_INPUT } from 'actions/form';

const initalState = {
  login: {
    userID: '',
    userPWD: ''
  }
};

function form(state = initalState, action) {
  const { payload } = action;

  switch (action.type) {
    case CHANGE_INPUT:
      return {
        ...state,
        [payload.form]: {
          ...state[payload.form],
          [payload.name]: payload.value
        }
      };

    default:
      return state;
  }
}

export default form;
